import React from 'react';
import { coveragesList } from 'const/coverages';
import { isMobile } from 'react-device-detect';
import { View } from '@coinscrap/webapp-core';
import { PackageCoverageCard } from './PackageCoverageCard';
import { PackageCoverageHeader } from './PackageCoverageHeader';

export const Packages = ({ packages, selectedPack, resumePdf, selectPack }) => {
	return (
		<View gap4St style={{ marginTop: 16, marginBottom: isMobile ? 20 : 0 }}>
			<PackageCoverageHeader
				packages={packages}
				selectedPack={selectedPack}
				selectPack={selectPack}
			/>
			{coveragesList.length > 0 &&
				coveragesList.map((coverage, index) => (
					<PackageCoverageCard
						key={index}
						index={index}
						coverage={coverage}
						packages={packages}
						resumePdf={resumePdf}
					/>
				))}
		</View>
	);
};
